import { Component, OnInit, Input, OnDestroy, ElementRef, OnChanges, HostListener } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { EMPTY, Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { BroadcastingsService } from 'src/app/services/broadcastings-services/broadcastings.service';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-broadcastings-tv-format-layout-info-card',
  templateUrl: './broadcastings-tv-format-layout-info-card.component.html',
  styleUrls: ['./broadcastings-tv-format-layout-info-card.component.scss']
})
export class BroadcastingsTvFormatLayoutInfoCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() tvFormatDeviceInfo;
  @Input() tvFormatShapes;
  @Input() tvFormatDesks;
  editingLocked: boolean;
  updateTvFormatLayoutSubscription: Subscription;
  basicDataForm = new FormGroup({
    selectedLayout: new FormControl(null),
    checkPrincipalDesk: new FormControl(false),
    principalDesk: new FormControl(null),
    backgroundColour: new FormControl(null),
    textPrimaryColour: new FormControl(null),
    textSecondaryColour: new FormControl(null)
  });

  constructor(private eRef: ElementRef,
    private broadcastingsService: BroadcastingsService,
    private snackBarService: SnackBarService) { }

  ngOnInit() {
    this.editingLocked = true;
  }

  ngOnChanges() {
    if (this.tvFormatDeviceInfo) {
      this.resetForm();
      this.lockEdition();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {

    } else {
      if (event.path[0].className !== 'mat-option-text') {
        if (this.tvFormatDeviceInfo && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
          this.editingLocked = true;
        }
      }
    }
  }

  public submitForm() {
    this.updateTvFormatLayoutSubscription = this.broadcastingsService.updateTvFormatLayout(this.tvFormatDeviceInfo.InternalId, this.getSelectedTvFormatLayout(), this.basicDataForm.get('checkPrincipalDesk').value, this.getSelectedTvFormatDesk(),  this.basicDataForm.get('backgroundColour').value, this.basicDataForm.get('textPrimaryColour').value, this.basicDataForm.get('textSecondaryColour').value).pipe(
      tap(o => this.snackBarService.open('devices-page.snackbar messages.update device success', 'success')),
      tap(o => this.lockEdition()),
      tap(o => this.broadcastingsService.refreshTvFormat()),
      catchError(error => { this.snackBarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
      } else {
        this.snackBarService.open(validation, 'error');
      }
    }
  }

  private validateForm() {
    if (this.basicDataForm.get('checkPrincipalDesk').value && !this.basicDataForm.get('principalDesk').value) {
      return 'turns-page.snackbar messages.principal desk error';
    } else {
      return true;
    }
  }

  public resetForm() {
    console.dir(this.tvFormatDeviceInfo.TvLayout);
    this.basicDataForm.patchValue({
      selectedLayout: this.setSelectedTvFormatLayout(),
      checkPrincipalDesk: this.tvFormatDeviceInfo.CheckPrincipalDesk,
      principalDesk: this.setSelectedTvFormatDesk(),
      backgroundColour: this.tvFormatDeviceInfo.TvLayout.BackgroundColour,
      textPrimaryColour: this.tvFormatDeviceInfo.TvLayout.TextPrimaryColour,
      textSecondaryColour: this.tvFormatDeviceInfo.TvLayout.TextSecondaryColour
    });
  }

  private unlockEdition() {
    this.basicDataForm.get('selectedLayout').enable();
    this.basicDataForm.get('checkPrincipalDesk').enable();
    this.basicDataForm.get('principalDesk').enable();
    this.basicDataForm.get('backgroundColour').enable();
    this.basicDataForm.get('textPrimaryColour').enable();
    this.basicDataForm.get('textSecondaryColour').enable();
    this.editingLocked = false;
  }

  private lockEdition() {
    this.basicDataForm.get('selectedLayout').disable();
    this.basicDataForm.get('checkPrincipalDesk').disable();
    this.basicDataForm.get('principalDesk').disable();
    this.basicDataForm.get('backgroundColour').disable();
    this.basicDataForm.get('textPrimaryColour').disable();
    this.basicDataForm.get('textSecondaryColour').disable();
    this.editingLocked = true;
  }

  public setSelectedTvFormatLayout() {
    if (this.tvFormatDeviceInfo && this.tvFormatShapes) {
      for (const layout of this.tvFormatShapes) {
        if (layout.InternalId === this.tvFormatDeviceInfo.TvLayout.InternalId) {
          return layout;
        }
      }
    } else {
      return null;
    }
  }

  public setSelectedTvFormatDesk() {
    if (this.tvFormatDeviceInfo && this.tvFormatDesks) {
      for (const tvFormatDesk of this.tvFormatDesks) {
        if (tvFormatDesk.InternalId === this.tvFormatDeviceInfo.PrincipalDeskInternalId) {
          return tvFormatDesk;
        }
      }
    } else {
      return null;
    }
  }

  public getSelectedTvFormatLayout() {
    if (this.tvFormatDeviceInfo && this.tvFormatShapes.length > 0) {
      if (this.basicDataForm.get('selectedLayout').value) {
        return this.basicDataForm.get('selectedLayout').value.InternalId;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  public getSelectedTvFormatDesk() {
    if (this.tvFormatDeviceInfo && this.tvFormatDesks.length > 0) {
      if (this.basicDataForm.get('principalDesk').value) {
        return this.basicDataForm.get('principalDesk').value.InternalId;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  public getLayoutInfo(formatShape) {
    switch (formatShape.TvFormatCode) {
      case 'FULL_SCREEN':
        return { thumbnail: 'assets/images/placeholder_format_fullscreen.png', orientation: 'landscape', html5: true, android: true, led: false };
      case 'L_SHAPE':
        return { thumbnail: 'assets/images/placeholder_format_l_shape.png', orientation: 'landscape', html5: true, android: true, led: false };
      case 'BOTTOM_BANNER':
        return { thumbnail: 'assets/images/placeholder_format_bottom_banner.png', orientation: 'landscape', html5: true, android: true, led: false };
      case 'BOTTOM_CARDS':
        return { thumbnail: 'assets/images/placeholder_format_bottom_cards.png', orientation: 'landscape', html5: true, android: true, led: false };
      case 'PORTRAIT':
        return { thumbnail: 'assets/images/placeholder_format_portrait.png', orientation: 'portrait', html5: false, android: true, led: false };
      case 'FIXED_BOTTOM_IMAGE':
        return { thumbnail: 'assets/images/placeholder_format_vertical.png', orientation: 'portrait', html5: false, android: true, led: false };
      case 'VERTICAL_BROADCASTING_LAYOUT':
        return { thumbnail: 'assets/images/placeholder_format_vertical_broadcasting.png', orientation: 'portrait', html5: true, android: true, led: false };
      case 'SERVICE_FULLSCREEN':
        return { thumbnail: 'assets/images/placeholder_format_service_fullscreen.png', orientation: 'landscape', html5: true, android: true, led: false };
      case 'L_SHAPE_TOP':
        return { thumbnail: 'assets/images/placeholder_format_l_shape_top.png', orientation: 'landscape', html5: true, android: true, led: false };
      case 'OCCUPATION_LAYOUT':
        return { thumbnail: 'assets/images/placeholder_format_occupation.png', orientation: 'landscape', html5: false, android: true, led: false };
      case 'OCCUPATION_LAYOUT_VERTICAL':
        return { thumbnail: 'assets/images/placeholder_format_occupation_vertical.png', orientation: 'portrait', html5: false, android: true, led: false };
      case 'SINGLE_ROW_LAYOUT':
        return { thumbnail: 'assets/images/placeholder_format_single_row.png', orientation: 'landscape', html5: false, android: true, led: false };
      case 'LANDSCAPE_LAYOUT':
        return { thumbnail: 'assets/images/placeholder_format_landscape.png', orientation: 'landscape', html5: false, android: true, led: false };
      case 'LAST_TURNS_LAYOUT':
        return { thumbnail: 'assets/images/placeholder_format_last_turns.png', orientation: 'landscape', html5: false, android: true, led: false };
      case 'LAST_TURNS_LAYOUT_2':
        return { thumbnail: 'assets/images/placeholder_format_last_turns_2.png', orientation: 'landscape', html5: false, android: true, led: false };
      case 'LED_MULTI_DESK_SUMMARY':
        return { thumbnail: 'assets/images/LED_MULTI_DESK_SUMMARY.svg', orientation: 'landscape', html5: false, android: false, led: true };
      case 'LED_DESK_TURN_NAME':
        return { thumbnail: 'assets/images/LED_DESK_TURN_NAME.svg', orientation: 'landscape', html5: false, android: false, led: true };
      case 'LED_FULL_TURN':
        return { thumbnail: 'assets/images/LED_FULL_TURN.svg', orientation: 'landscape', html5: false, android: false, led: true };
      case 'LED_DESK_AND_TURN':
        return { thumbnail: 'assets/images/LED_DESK_AND_TURN.svg', orientation: 'landscape', html5: false, android: false, led: true };
    }
  }
  ngOnDestroy() {
    if (this.updateTvFormatLayoutSubscription) { this.updateTvFormatLayoutSubscription.unsubscribe(); }
  }
}
